






















import { ElTable } from "element-ui/types/table";
import { Mixins, Component, Prop, Watch, Emit } from "vue-property-decorator";
import { IBarcodeItem } from "../../../../../../domain/editableFormat/objects/IBarcodeObject";
import { IBarcodeInformationSpecification } from "../../../../../../domain/editableFormat/IFormatSpecification";

@Component
export default class BarcodeItemSelector extends Mixins() {
  @Prop({ default: false })
  shouldShowType: boolean;

  @Prop({ default: () => [] as IBarcodeItem[] })
  items: IBarcodeItem[];

  @Prop({ default: () => [] as IBarcodeInformationSpecification[] })
  barcodeInformations: IBarcodeInformationSpecification[];

  $refs!: {
    table: ElTable,
  };

  toTypeString(row: IBarcodeItem): string {
    return row.isHisItem
      ? "選択項目"
      : "固定文字";
  }

  toNameString(row: IBarcodeItem): string {
    if (row.isHisItem) {
      const barcodeInformations = this.barcodeInformations.filter(o => o.key === row.value);
      if (barcodeInformations.length > 0) {
        return barcodeInformations[0].name;
      }
    }
    return row.value;
  }

  @Watch("items")
  onItemsUpdated(newValue: IBarcodeItem[], oldValue: IBarcodeItem[]) {
    // element-uiのテーブルにスクロールバーが表示される際、ヘッダがずれる問題に対応するため、dataプロパティ更新時に遅延でdoLayoutを呼び出す
    this.$nextTick(() => this.$doWhenValid(t => t.doLayout(), this.$refs.table));
  }

  @Emit()
  selectionChange(value: IBarcodeItem[]): void {}
}
